import React from 'react'

const Jva_N = () => {
    return (
        <div className='container'>
            <h1>Java Program to Print Natural Numbers from 1 to N</h1>
            <p>Write a Java Program to Print Natural Numbers from 1 to N using For Loop, and While Loop with an example.</p>
            <h2>Java Program to Print Natural Numbers from 1 to N</h2>
            <p>This program allows the user to enter any integer value(the maximum limit value). Next, this Java program displays all the natural numbers from 1 to maximum limit value (N) using For Loop</p>
            <pre class="containers">// Java Program to Print Natural Numbers from 1 to N 
   import java.util.Scanner; <br/>
    <br/>
   public class NaturalNumbers1 &#123; <br/>
      private static Scanner sc; <br/>
      public static void main(String[] args)  <br/>
      &#123; <br/>
         int number, i; <br/>
         sc = new Scanner(System.in); <br/>
          <br/>
         System.out.print(" Please Enter any Number : "); <br/>
         number = sc.nextInt();	 <br/>
          <br/>
         for(i = 1; i &lt;= number; i++) <br/>
         &#123; <br/>
            System.out.print(i +"\t");  <br/>
         &#125;	 <br/>
      &#125; <br/>
   &#125;</pre>
   <h3>Dry run</h3>
   <div className='output'> 
   <p>Suppose, User entered value: number&nbsp; = 6</p>
   <p>For Loop First Iteration:&nbsp;for(i = 1; i &lt;= 6; i++)<br/>Condition is True. So, i Value printed (i.e., 1)</p>
   <p>Second Iteration:&nbsp;for(i = 2; 2 &lt;= 6; 2++)<br/>
   Condition is True. It prints 2</p><p>Third Iteration: for(i = 3; 3 &lt;= 6; 3++)<br/>
   Condition is True. It prints 3</p>
   <p>Fourth Iteration: for(i = 4; 4 &lt;= 6; 4++)<br/>
   Condition is True. 4 printed.</p>
   <p>Fifth Iteration: for(i = 5; 5 &lt;= 6; 5++)<br/>
   Condition is True. It prints 5</p>
   <p>Sixth Iteration: for(i = 6; 6 &lt;= 6; 6++)<br/>
   Condition is True. 6 printed</p>
   <p>7th Iteration: for(i = 7; 7 &lt;= 6; 7++)<br/>
   Condition (7 &lt;= 6) is False. So, the Java compiler exits from the For Loop</p></div>
   <h2>Java Program to Print Natural Numbers from 1 to N using While loop</h2>
   <p>This Java program to return natural numbers from 1 to N is the same as the above example, but we are using the While Loop.</p>
   <pre class="containers">// Java Program to Print Natural Numbers from 1 to N  <br />
   import java.util.Scanner; <br/>
    <br/>
   public class NaturalNumbers2 &#123; <br/>
      private static Scanner sc; <br/>
      public static void main(String[] args)  <br/>
      &#123; <br/>
         int number, i = 1; <br/>
         sc = new Scanner(System.in); <br/>
          <br/>
         System.out.print(" Please Enter any Number : "); <br/>
         number = sc.nextInt();	 <br/>
          <br/>
         while(i &lt;= number) <br/>
         &#123; <br/>
            System.out.print(i +"\t");  <br/>
            i++; <br/>
         &#125;	 <br/>
      &#125; <br/>
   &#125;</pre> <br/>
        </div>
    )
}

export default Jva_N
